import type { SVGProps } from 'react'
const SolidCheck = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={16}
		height={16}
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M13.5316 3.92968C13.9135 4.32114 13.9135 4.95569 13.5316 5.34695L6.9729 12.0701C6.59101 12.4613 5.97215 12.4613 5.59025 12.0701L2.46806 8.86949C2.08617 8.47823 2.08617 7.84368 2.46806 7.45241C2.84977 7.06095 3.46882 7.06095 3.85053 7.45241L6.28148 9.94424L12.1489 3.92968C12.5308 3.53841 13.1499 3.53841 13.5316 3.92968Z"
			fill="currentColor"
		/>
	</svg>
)
export { SolidCheck }
